import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=1d13abbd&scoped=true&"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js&"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDataTable.vue?vue&type=style&index=0&id=1d13abbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13abbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
})
